import React, { FC, memo } from "react"
import {
  RootStyled,
  TitleStyled,
  SubtitleStyled,
  WrapLeftStyled,
  WrapRightStyled,
  WrapRightContentStyled,
  TitleRedStyled,
  ImageStyled,
} from "./styles"
import background from "./images/background.webp"
import speaker from "./images/speaker.webp"

export const WhatWeOffer: FC = memo(() => {
  return (
    <RootStyled style={{ backgroundImage: `url(${background})` }} id="offer">
      <WrapLeftStyled>
        <ImageStyled src={speaker} alt="" loading="lazy" />
      </WrapLeftStyled>
      <WrapRightStyled>
        <WrapRightContentStyled>
          <TitleStyled>
            IN THE MEANTIME... FOCUS ON THE IMPORTANT THINGS.
          </TitleStyled>
          <TitleRedStyled>WHAT WE OFFER?</TitleRedStyled>
          <SubtitleStyled>
            Avatars as AI Assistants that resolve real-life challenges and
            create emotional connections with you or your potential clients.
          </SubtitleStyled>
        </WrapRightContentStyled>
      </WrapRightStyled>
    </RootStyled>
  )
})
